export const body = {
    paddingRight: "30px",
    paddingTop: "20px"
};

export const headerCenter = {
    textAlign: "center"
};

export const mobile_body = {
    paddingTop: "20px"
};
